import { assign } from 'xstate';
import merge from 'lodash.merge';
import { PaymentContext, PaymentEvent } from '../../../types';
import { generateUniqueReferenceNumber } from '../../../utils';
import { v4 as uuidv4 } from 'uuid';

export const startStateMachineContext = assign<PaymentContext, PaymentEvent>((context, event) => {
  const updatedContext = merge({}, context, {
    amount: event?.amount,
    config: merge({}, context.config, event.config),
    idempotencyKey: uuidv4(),
    referenceNumber: context.referenceNumber || generateUniqueReferenceNumber(),
  });
  logger.debug(
    `[@fingermarkglobal/elavon] - Starting Context - amount: ${updatedContext.amount}, config:${updatedContext.config
    }, idempotencyKey: ${updatedContext.idempotencyKey} - startStateMachineContext()`,
  );
  return updatedContext;
});
